var address = {};
module['exports'] = address;
address.state = require("./state");
address.state_abbr = require("./state_abbr");
address.default_country = require("./default_country");
address.postcode = require('./postcode.js');



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/address/index.js
// module id = 1110
// module chunks = 0